import { createContext, use } from 'react';

const NO_SUPERSEDED_MESSAGES: ReadonlySet<string> = new Set();

/**
 * Ids of messages whose prose no longer reflects reality. Their text parts are
 * not shown; their other parts (widgets, tool calls) still render.
 */
export const SupersededMessageTextContext = createContext<ReadonlySet<string>>(NO_SUPERSEDED_MESSAGES);

/**
 * Reads the ids of messages whose text has been superseded.
 *
 * @returns The superseded message ids; empty outside a provider.
 */
export function useSupersededMessageTextIds(): ReadonlySet<string> {
	return use(SupersededMessageTextContext);
}
